import { Button } from 'antd';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { AppAlert } from '@components/antd';
import { capitalizeFirst } from '@shared/utils/capitalize';
import { useSupportChat } from '@shared/hooks/use-support-chat';
import { INR_FLOW_MESSAGES } from './inr-payment-alert.constant';
import { InrPaymentAlertProps } from './inr-payment-alert.types';

export function InrPaymentAlert({ flow, className }: InrPaymentAlertProps) {
  const { t } = useTranslation();
  const { openSupportChat, setMessage } = useSupportChat();

  const handleContactSupport = () => {
    setMessage(INR_FLOW_MESSAGES[flow]);
    openSupportChat();
  };

  return (
    <AppAlert
      type="info"
      showIcon
      className={clsx('app-alert', className)}
      message={
        <span className="text-xs">
          {t('prefer_to_pay_in_inr')}{' '}
          <Button type="link" size="small" className="px-0! text-xs! underline!" onClick={handleContactSupport}>
            {capitalizeFirst(t('contact_support'))}
          </Button>
        </span>
      }
    />
  );
}
